export type ChecklistSize = 'sm' | 'md' | 'lg';
export type ChecklistVariant = 'light' | 'dark';
export type ChecklistIconStyle = 'check' | 'circle-check';

export type TextItem = {
  id?: number;
  text: string;
};

export type ChecklistProps = {
  items: TextItem[];
  iconName?: ChecklistIconStyle;
  size?: ChecklistSize;
  variant?: ChecklistVariant;
  className?: string;
};

export const SIZE_STYLES: Record<ChecklistSize, string> = {
  sm: 'gap-2 text-sm',
  md: 'gap-3 text-base',
  lg: 'gap-4 text-lg',
};

export const ICON_SIZE: Record<ChecklistSize, number> = {
  sm: 14,
  md: 16,
  lg: 18,
};

export const ICON_WRAPPER_SIZE: Record<ChecklistSize, string> = {
  sm: 'w-[24px] h-[24px]',
  md: 'w-[36px] h-[36px]',
  lg: 'w-[42px] h-[42px]',
};

export const TEXT_VARIANT: Record<ChecklistVariant, string> = {
  light: 'text-slate-900',
  dark: 'text-white',
};
